import { Reducer } from "redux";

import { FailedUploadActionTypes, IFailedUploadState, emptyQueryResult } from "./types";

const initialState: IFailedUploadState = {
  data: emptyQueryResult,
  errors: undefined,
  loading: false,
};

const reducer: Reducer<IFailedUploadState> = (state = initialState, action) => {
  switch (action.type) {
    case FailedUploadActionTypes.FETCH_REQUEST: {
      return { ...state, errors: undefined, loading: true, data: emptyQueryResult };
    }
    case FailedUploadActionTypes.FETCH_SUCCESS: {
      return { ...state, errors: undefined, loading: false, data: action.payload };
    }
    case FailedUploadActionTypes.FETCH_ERROR: {
      return { ...state, loading: false, errors: action.payload };
    }
    default: {
      return state;
    }
  }
};

export { reducer as failedUploadReducer };
